import { Routes, Route, Navigate } from "react-router";
import { Box } from '@mui/material';
import ClientO365 from "../pages/client/ClientO365";
import ClientEset from "../pages/client/ClientEset";
import ClientPeople from "../pages/client/ClientPeople";
import ClientDashboardHome from "../pages/client/ClientDashboardHome";

function MainViewClient({ data }) {
  return (
    <Box display={'flex'} flexDirection={'column'} flexGrow={1}>
        <Routes>
          <Route path="home" element={<ClientDashboardHome />} />
          <Route path="o365" element={<ClientO365 />} />
          <Route path="eset" element={<ClientEset />} />
          <Route path="staff" element={<ClientPeople />} />
          <Route index element={<Navigate to="home" />} />
        </Routes>
    </Box>
  )
}

export default MainViewClient